import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import initMiniConfig from './utils/miniConfig';

createApp(App).use(store).use(router).mount('#app');
// 初始化小程序配置
initMiniConfig();
